import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { badges as badges$1 } from '@costar/theme-ui';

var innerDot = {
  content: '""',
  display: 'block',
  position: 'absolute',
  background: 'white',
  width: '0.2em',
  height: '0.2em',
  borderRadius: '100%'
};
var badges = _objectSpread2({}, Object.keys(badges$1).reduce(function (acc, cur) {
  return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, cur, function (theme, props) {
    var baseTheme = badges$1[cur](theme, props);
    return _objectSpread2(_objectSpread2({}, baseTheme), {}, {
      '&.dot': _objectSpread2(_objectSpread2({}, baseTheme['&.dot']), {}, {
        height: '1em',
        minWidth: '1em'
      }),
      '&.dot::after': _objectSpread2(_objectSpread2({}, innerDot), cur === 'white' ? {
        background: 'primary'
      } : {})
    });
  }));
}, {}));

export { badges };
//# sourceMappingURL=badges.esm.js.map
